import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.js"
import { ThemeProvider } from "styled-components"
import { GlobalStyles } from "./styles/GlobalStyles.js"
import { theme } from "./styles/theme.js"
import { AppProvider } from "./contexts/AppContext.jsx"

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AppProvider>
        <App />
      </AppProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
